import ecommerce from 'core/pkg/ecommerce'
import http from 'core/pkg/http'
import isEmpty from 'lodash/isEmpty'
import Qs from 'qs'
// import { message } from 'antd'

export default {
  init({ getToken, hasMock, mockDelay, baseURL }, services) {
    const httpInstance = http.init(
      {
      baseURL: baseURL,
      // timeout: 10000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      validateStatus: status => {
        if (status === 401) {
          localStorage.removeItem("customer_token");

          setTimeout(() => {
            window.location.reload();
          }, 1000)

          // console.log('status is:', status)
          console.log('http instance:', httpInstance)
          console.table({ 'status': status, 'base url': baseURL })
        }

        return status >= 200 && status < 300
      },
      transformRequest: [
        (data, headers) => {
          if (headers['Content-Type'] !== 'multipart/form-data') {
            let _data = services.utils.transform.camelToSnake(data)

            _data = JSON.stringify(_data)

            return _data
          }

          return data
        }
      ],
      transformResponse: [
        data => {
          if (isEmpty(data)) {
            return data
          }

          let _data = JSON.parse(data)
          _data = services.utils.transform.snakeToCamel(_data)

          return _data
        }
      ],
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })

    // Add authorization token to requests
    httpInstance.addRequestMiddleware((url, opts) => {
      opts.options.headers.Authorization = getToken ? getToken() : ''
    })

    // httpInstance.addResponseMiddleware(response => {
    //   console.log('addResponseMiddleware response => ', response)
    //   message.success("text", 1)
    //   return response
    // }, err => {
    //   console.log('addResponseMiddleware error =>', err)
    //   return Promise.reject(parseResponse(err))
    // })

    // Configure mock adapter
    if (hasMock) {
      httpInstance.enableMock({ delayResponse: mockDelay })
    }

    return ecommerce.init({ handler: httpInstance })
  }
}
